// extracted by mini-css-extract-plugin
export default {"button":"button_button__Azq7m","icons":"button_icons__hhmtT"};